import { IProfile, IProfileResponse } from './profileresponse.model';
export class User {
    jwt: JWT;
    userName: string;
    // currentProfile: IProfileResponse;
    profile: IProfile;
    profiles: IProfile[];
}
